<template>
  <div >
    <ul class="iconos">
      <li class=""> 
          <img src="../assets/img/asesoria-icon.png"/>
          <h3 class="titulo-3">ASESORIA</h3>
      </li>
      <li class=""> 
          <img src="../assets/img/envios.png"/>
          <h3 class="titulo-3">ENVIOS NACIONALES</h3>
      </li>
      <li class=""> 
          <img src="../assets/img/compra-linea.png"/>
          <h3 class="titulo-3">COMPRA EN LINEA</h3>
      </li>
      <li class=""> 
          <img src="../assets/img/visitanos.png"/>
          <h3 class="titulo-3">VISITANOS</h3>
      </li>
     
    </ul>
 
  </div>
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'

  export default {
    name:'iconos',
    data() {
      return {
       
      }
    },
    methods: {
    handleResize() {
     
     }
    },
    beforeCreate(){
        
    },
    computed: {
      ...mapState(['featuredProducts'])
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    background-color: transparent;
  }
 
</style>